import {
  NotificationCounterType,
  NotificationType,
  WorkspaceNotificationType,
} from '@ts/userOrganization.types';

import streamRequest from '@api/base/streamRequest';
import request from '@api/base/request';
import userOrganizationService from '@api/services/userOrganizationService';

import {
  WorkspaceNotificationChannel,
  WorkspaceNotificationRequest,
} from 'respona_api/generated/user-organization_pb';
import {
  IdRequest,
  PageRequest,
  WorkspaceNotificationChannelIntegration,
} from 'respona_api/generated/common_pb';
import * as common_pb from 'respona_api/generated/common_pb';

export const getNotificationsApi = (
  workspaceId: number,
  page: number,
  limit: number
): Promise<NotificationType[]> => {
  const service = userOrganizationService.getInstance();
  const workspacesRequest = new WorkspaceNotificationRequest();

  workspacesRequest.setWorkspaceId(workspaceId);
  workspacesRequest.setPage(page);
  workspacesRequest.setLimit(limit);

  return streamRequest<NotificationType[]>(service, service.getNotifications, workspacesRequest);
};

export const markNotificationAsSeenApi = (
  notificationId: number,
  workspaceId: number
): Promise<void> => {
  const service = userOrganizationService.getInstance();
  const idRequest = new IdRequest();

  idRequest.setId(notificationId);
  idRequest.setOptionalWorkspaceId(workspaceId);

  return request<void>(service, service.markNotificationAsSeen, idRequest);
};

export const deleteNotificationApi = (
  notificationId: number,
  workspaceId: number
): Promise<void> => {
  const service = userOrganizationService.getInstance();
  const idRequest = new IdRequest();

  idRequest.setId(notificationId);
  idRequest.setOptionalWorkspaceId(workspaceId);

  return request<void>(service, service.deleteNotification, idRequest);
};

export const getNotificationCountersApi = (
  workspaceId: number
): Promise<NotificationCounterType> => {
  const service = userOrganizationService.getInstance();
  const idRequest = new IdRequest();

  idRequest.setId(workspaceId);

  return request<NotificationCounterType>(service, service.getNotificationCounters, idRequest);
};

export const deleteNotificationChannelApi = (
  notificationId: number
): Promise<NotificationCounterType> => {
  const service = userOrganizationService.getInstance();
  const idRequest = new IdRequest();

  idRequest.setId(notificationId);

  return request<NotificationCounterType>(service, service.deleteNotificationChannel, idRequest);
};

export const createOrUpdateNotificationChannelApi = (
  notificationId: number,
  workspaceIds: number[],
  channel: common_pb.WorkspaceNotificationChannelMap[keyof common_pb.WorkspaceNotificationChannelMap],
  title: string,
  webhookUrl: string
): Promise<WorkspaceNotificationType> => {
  const service = userOrganizationService.getInstance();
  const channelRequest = new WorkspaceNotificationChannel();
  if (notificationId != null) channelRequest.setId(notificationId);
  channelRequest.setChannel(channel);
  channelRequest.setWorkspaceIdsList(workspaceIds);
  channelRequest.setTitle(title);
  channelRequest.setIntegration(WorkspaceNotificationChannelIntegration.SLACK);

  const slack = new WorkspaceNotificationChannel.SlackIntegration();
  slack.setWebhookUrl(webhookUrl);

  channelRequest.setSlack(slack);

  return request<WorkspaceNotificationType>(
    service,
    service.createOrUpdateNotificationChannel,
    channelRequest
  );
};

export const getNotificationChannelsApi = (
  page: number,
  limit: number
): Promise<WorkspaceNotificationType[]> => {
  const service = userOrganizationService.getInstance();
  const pageRequest = new PageRequest();

  pageRequest.setLimit(limit);
  pageRequest.setPage(page);

  return streamRequest<WorkspaceNotificationType[]>(
    service,
    service.getNotificationChannels,
    pageRequest
  );
};
